import { useEffect, useState, useRef } from "react";
import "./css/HiringCarousel.css";
import "./css/AboutStudentsPics.css";
const slides = [
  {
    src: "./Students/1.png",
    alt: "Students",
  },
  {
    src: "./Students/2.png",
    alt: "Students",
  },
  {
    src: "./Students/3.png",
    alt: "Students",
  },
];

const AboutStudentsPics = () => {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
    resetInterval();
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
    resetInterval();
  };

  const resetInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
  };

  useEffect(() => {
    resetInterval();
    return () => clearInterval(intervalRef.current);
  }, []);

  return (
    <div className="">
      {/* <h1 className="heading-text-4">IIITH_prep</h1> */}
      <div className="outer-container-2">
        <div className="carousel-container-2">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-slide ${index === current ? "active" : ""}`}
              style={{ pointerEvents: index === current ? "auto" : "none" }}
            >
              <img
                src={slide.src}
                alt={slide.alt}
                className="responsive-image-2"
              />
            </div>
          ))}

          {/* Arrows */}
        </div>
        {/* <Link to="/iiithcourseform">
          <button
            style={{
              marginTop: "30px",
              background: "linear-gradient(to right, #4ECDC4, #2196F3)",
              color: "white",
              padding: "15px 40px",
              borderRadius: "30px",
              border: "none",
              fontWeight: "600",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            Register Now!
          </button>
        </Link> */}
        <button className="arrow left-arrow" onClick={prevSlide}>
          &#10094;
        </button>
        <button className="arrow right-arrow" onClick={nextSlide}>
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default AboutStudentsPics;
